<template>
  <div
    class="tab-pane fade"
    id="certificate"
    role="tabpanel"
    aria-labelledby="certificate-tab"
  >
    <div class="card-body">
      <h4 class="card-title mb-3">TBA</h4>

      <p>The table below shows the list of TBA purchases.</p>

      <div class="table-responsive">
        <table
          id="tba_certificate_tbl"
          class="display table table-striped table-bordered"
          style="width:100%; text-align: center;"
        >
          <thead>
            <tr>
              <th>No.</th>
              <th>Product</th>
              <th>Type</th>
              <th>Date Purchased</th>
              <th>Officer</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(cert, i) in tbaCert" :key="i">
              <td>{{ i + 1 }}</td>
              <td>{{ cert.product.name }}</td>
              <td>
                <span v-if="cert.details_meta.length > 0">{{
                  cert.details_meta[0].meta_value
                }}</span>
              </td>
              <td>{{ cert.created_at | moment("Do MMMM YYYY, h:mm:ss a") }}</td>
              <td>{{ staff(cert) }}</td>
              <td>{{ cert.status.name }}</td>
              <td>
                <router-link
                  :to="purchaseDetail(cert.id)"
                  type="button"
                  class="btn btn-success btn-rounded btn-block"
                  style="background-color: #78BE20; border-color: #78BE20;"
                >
                  View Details
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";

export default {
  name: "customer_certificate",
  components: {},

  data() {
    return {
      tbaCert: []
    };
  },

  methods: {
    loadCertificate() {
      let token = localStorage.getItem("token");
      let customer_id = this.$route.params.id;

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get("/tba/purchase/filter?customer=" + customer_id, {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            this.tbaCert = res.data;
            setTimeout(function() {
              $("#tba_certificate_tbl").DataTable({
                dom: "Bfrtip",
                buttons: ["excel", "pdf"]
              });
            }, 500);
          });
      }
    },

    staff(cert) {
      if (!cert.staff.name) {
        return cert.staff.user.name;
      }
    },

    purchaseDetail(id) {
      return "/tba/details/" + id;
    },

    formatStatus(status_id) {
      switch (status_id) {
        case 1:
          return "Quote Request";
          break;

        case 2:
          return "Quote Provided";
          break;

        case 3:
          return "Paid";
          break;

        case 4:
          return "In Process";
          break;

        case 5:
          return "Completed";
          break;

        case 6:
          return "Approved";
          break;

        case 7:
          return "Rejected";
          break;

        case 8:
          return "Settled";
          break;

        case 9:
          return "Failed";
          break;
      }
    }
  },

  mounted() {
    this.loadCertificate();
  }
};
</script>
